import { URLS } from '@/constants';
import { PaginatedResponse } from '@/models/api';
import { PackingOrder, Tote } from '@/models/shipAssist';
import { apiSlugSession } from '@/services/session';

export const managedBrandSellerParam = ({ sellerId }) => (sellerId ? `&managed_brand_seller_id=${sellerId}` : '');

/**
 * Get Ship Assist totes
 * @param {string} params Serialized GET params from ServerListItem (or "from api-driven LLListView")
 */
export const getTotes = async (params: string): Promise<PaginatedResponse> => {
  const url = `${URLS.SHIP_ASSIST.BASE}/${URLS.SHIP_ASSIST.TOTES}/?${URLS.CUSTOM_ERROR}&${params}`;

  const response = await apiSlugSession.get(url);

  return response.data;
};

/**
 * Get Packing Orders from API
 * @type {object} params Any parameters for the endpoint.
 */
export const getPackingOrder = async (payload: { id: string; sellerId: number }): Promise<PackingOrder> => {
  const { id, sellerId } = payload;
  const url = `${URLS.SHIP_ASSIST.BASE}/${URLS.SHIP_ASSIST.PACKING_ORDERS}/${id}/?${
    URLS.CUSTOM_ERROR
  }${managedBrandSellerParam({ sellerId })}&limit=10000`;

  const response = await apiSlugSession.get(url);

  return response.data;
};

/**
 * Create packing order
 * @type {object} params Any parameters for the endpoint.
 */
export const createPackingOrder = async (payload: { number: string; sellerId: number }): Promise<PackingOrder> => {
  const url = `${URLS.SHIP_ASSIST.BASE}/${URLS.SHIP_ASSIST.PACKING_ORDERS}/?${URLS.CUSTOM_ERROR}`;

  const response = await apiSlugSession.post(url, { ...payload });

  return response.data;
};

/**
 * Create tote
 * @type {object} params Any parameters for the endpoint.
 */
export const createTote = async (payload: { tote: Tote; sellerId: number }): Promise<Tote> => {
  const { tote, sellerId } = payload;
  const url = `${URLS.SHIP_ASSIST.BASE}/${URLS.SHIP_ASSIST.TOTES}/?${URLS.CUSTOM_ERROR}${managedBrandSellerParam({
    sellerId,
  })}`;

  const response = await apiSlugSession.post(url, { ...tote });

  return response.data;
};

/**
 * Update tote
 * @type {object} params Any parameters for the endpoint.
 */
export const updateTote = async (payload: { tote: Tote; sellerId: number }): Promise<Tote> => {
  const { tote, sellerId } = payload;
  const url = `${URLS.SHIP_ASSIST.BASE}/${URLS.SHIP_ASSIST.TOTES}/${tote.id}/?${
    URLS.CUSTOM_ERROR
  }${managedBrandSellerParam({ sellerId })}`;

  const response = await apiSlugSession.patch(url, { ...tote });

  return response.data;
};

/**
 * Delete tote
 * @type {object} params Any parameters for the endpoint.
 */
export const deleteTote = async (payload: { id: string; sellerId: number }) => {
  const { id, sellerId } = payload;
  const url = `${URLS.SHIP_ASSIST.BASE}/${URLS.SHIP_ASSIST.TOTES}/${id}/?${URLS.CUSTOM_ERROR}${managedBrandSellerParam({
    sellerId,
  })}`;

  const response = await apiSlugSession.delete(url);

  return response.data;
};
